namespace HA.Core.Controller {
    import Tag = HA.Core.HTML.Tag;
    import Anchor = HA.Core.HTML.Anchor;
    import Data = HA.Core.Repository.Data;

    export interface IWebPageService {
        isActive: (d: any) => boolean;
        reloadApp: (d: any) => void;
        removeApp: (d: any) => void;
        replaceAppId: (id: any, newId: any) => void;
        setMainApp: (d: any) => void;
        showApp: (d: any) => void;
        showAppMenu: (id: any) => void;
        showFSApp: (d: any) => void;
        showPreviousApp: () => void;
        subscribeToAppInfo: (func: () => void) => void;
        toggleApp: (d: any) => void;
    }

    export class Controller extends HA.HAObject {
        private w4reload: any;

        protected click() {
            const data = toMap(this.get("click"));
            switch (data.get("func")) {
                case  "toggleApp" :
                    getWebPageService().toggleApp(data);
                    break;
                case  "showApp" :
                    getWebPageService().showApp(data);
                    break;
                case  "reloadApp" :
                    getWebPageService().reloadApp(data);
                    break;
                case  "showPreviousApp" :
                    getWebPageService().showPreviousApp();
                    break;
                case  "toggleQMenu" :
                    getWebPageService().toggleQMenu();
                    break;
                default :
                    break;
            }
        }

        protected initControllers() {
            const me = this;

            const tag: Tag = this.getTag();
            const controllersData = toMap(this.get("controllers"));
            controllersData.delete("pm");
            const controllers = new Map();
            controllersData.forEach((controllerData: any) => {
                controllerData = toMap(controllerData);
                const cname = controllerData.get("n");
                const cn = this.getControllerClass(cname);
                if (cn) {
                    const data = controllerData;
                    data.set("services", me.getServiceManager());
                    data.set("parentTag", tag);
                    data.set("appId", this.get("_id") || this.get("id"));
                    if (this.has("pfunc")) {
                        data.set("pfunc", this.get("pfunc"));
                    }
                    controllers.set(cname, new cn(data));
                }
            });
        }

        protected getControllerClass(name: string) {
            switch (name) {
                case "rl" :
                    return HA.Core.Controller.Page.SearchableController;
                case "m" :
                    return HA.Core.Controller.Page.MenuController;
            }
            return HA.Core.Controller.Page.SearchableController;
        }

        protected watch4Reload(func: () => void) {

            const me = this;
            me.w4reload = (event: Event) => {
                me.w4rListener(func);
            };

            document.addEventListener("scroll", me.w4reload);

        }

        protected w4rListener(func: () => void) {
            const element = document.scrollingElement;
            const a = element.scrollTop + element.clientHeight;

            if (a * 1.1 > element.scrollHeight) {
                func();
            }
        }

        protected removeWatch4Reload() {
            const me = this;
            document.removeEventListener("scroll", me.w4reload);
        }

        protected getDataRepository(): Data {
            if (this.hasNot("dataRepository")) {
                this.addToData("dataRepository", new HA.Core.Repository.Data());
            }

            return this.get("dataRepository");
        }
    }

}
